import React, { useState, useEffect, useRef, useLayoutEffect } from 'react'
import styled from 'styled-components'
// import KidsPinPopUp from './KidsPinPopUp'
// import { GlobalContext } from '../../context/global.context'
import { useSelector } from 'react-redux'



//-- General Focus Hook
const useFocus = () => {
    const htmlElRef = useRef(null)
    const setFocus = () => { htmlElRef.current && htmlElRef.current.focus() }

    return [htmlElRef, setFocus]
}



const KidsPinPopUp = ({ labels, successFunction = null, cancelFunction = null,  realPin = null, forgotFunction = null }) => {

   
    const [valueOne, setvalueOne] = useState('')
    const [valueTwo, setvalueTwo] = useState('')
    const [valueThree, setvalueThree] = useState('')
    const [valueFour, setvalueFour] = useState('')
    const [showWarning, setShowWarning] = useState(false)
    const [enableSubmit, setEnableSubmit] = useState(false)
    const { profileManagementThemes = {} } = useSelector(store => store.profileManagement)
    const [theme, setTheme] = useState(null)
    const [pin, setPin] = useState(0)

    // useEffect(() => {
    //     setPin(null)
    // },[])

    useEffect(() => {
        setTheme(profileManagementThemes.themeProfilePopup)
    }, [profileManagementThemes.themeProfilePopup])


    // const { dispatch } = useContext(GlobalContext)


   

    // const useMountEffect = (x) => useEffect(x, []);

    const { title = '', description = '', validationErrorText = '', forgetPinText = true,
        positiveButtonText = '', negativeButtonText = '' } = labels



    const [inputOneRef, setInputOneFocus] = useFocus()
    const [inputTwoRef, setInputTwoFocus] = useFocus()
    const [inputThreeRef, setInputThreeFocus] = useFocus()
    const [inputFourRef, setInputFourFocus] = useFocus()

    useEffect(() => { //setting initial focus to first digit entry
        setInputOneFocus()
        setShowWarning(false)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const permittedEntries = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
    useLayoutEffect(() => {
        if (permittedEntries.indexOf(valueOne) === -1) {
            setShowWarning(true)
            setvalueOne('')
        }
        else {
            setInputTwoFocus()
            if (showWarning) setShowWarning(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valueOne])
    useLayoutEffect(() => {
        if (permittedEntries.indexOf(valueTwo) === -1) {
            setShowWarning(true)
            setvalueTwo('')
        }
        else {
            setInputThreeFocus()
            if (showWarning) setShowWarning(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valueTwo])
    useLayoutEffect(() => {
        if (permittedEntries.indexOf(valueThree) === -1) {
            setShowWarning(true)
            setvalueThree('')
        }
        else {
            setInputFourFocus()
            if (showWarning) setShowWarning(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valueThree])
    useLayoutEffect(() => {
        if (permittedEntries.indexOf(valueFour) === -1) {
            setShowWarning(true)
            setvalueFour('')
        }
        else {
            if (showWarning) setShowWarning(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valueFour])



    useEffect(() => {

        if (valueOne !== '' &&
            valueTwo !== '' &&
            valueThree !== '' &&
            valueFour !== '') {
            setPin(`${valueOne}${valueTwo}${valueThree}${valueFour}`)
            setEnableSubmit(true)

        }
        else if (enableSubmit) setEnableSubmit(false)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valueOne, valueTwo, valueThree, valueFour, permittedEntries])

   

    const triggerSuccessFunction = () => {
        setvalueOne('')
        setvalueTwo('')
        setvalueThree('')
        setvalueFour('')
        successFunction(pin) 

    }

    const triggerCancelFunction = () => {
        setvalueOne('')
        setvalueTwo('')
        setvalueThree('')
        setvalueFour('')
        cancelFunction()
    }
   
    const triggerForgotPinFunction = () => {
        setvalueOne('')
        setvalueTwo('')
        setvalueThree('')
        setvalueFour('')
        forgotFunction()
        // cancelFunction()
    }


    return (
        <KidsPinPopUpStyled theme={theme}>
            <div className="child-lock-pin-full-screen-wrapper">
                <div className="child-lock-wrapper">
                    <div className="title">{title}</div>
                    <div className="description">{description}</div>
                    <div className="child-lock-pin-input">
                        <input id="one" ref={inputOneRef} value={valueOne} onChange={e => setvalueOne(e.target.value)} type="password" maxlength="1" />
                        <input id="two" ref={inputTwoRef} value={valueTwo} onChange={e => setvalueTwo(e.target.value)} type="password" maxlength="1" />
                        <input id="three" ref={inputThreeRef} value={valueThree} onChange={e => setvalueThree(e.target.value)} type="password" maxlength="1" />
                        <input id="four" ref={inputFourRef} value={valueFour} onChange={e => setvalueFour(e.target.value)} type="password" maxlength="1" />
                    </div>
                    <div className="secondary-description">
                        {!forgotFunction && <div className="secondary-description-validation">
                            {showWarning ? validationErrorText : ' '}
                        </div>}
                        {forgotFunction && <div className="secondary-description-forget-pin" onClick={() => triggerForgotPinFunction()}>
                            {forgetPinText ? 'FORGET PIN' : '' }
                        </div>}
                        
                    </div>
                    <div className='button_positive' style={enableSubmit ? { 'opacity': '1' } : { 'opacity': '0.5' }} onClick={enableSubmit ? () => triggerSuccessFunction(): () => { }} >{positiveButtonText}</div>
                    <div className="button_negative" onClick={() => triggerCancelFunction()}>{negativeButtonText}</div>
                </div>
            </div>
        </KidsPinPopUpStyled>
    )
}

const KidsPinPopUpStyled = styled.div`
.child-lock-pin-full-screen-wrapper{
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 10;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #00000080;
    .child-lock-wrapper{
        
        height: 376px;
        width: 342px;
        background-color: ${( { theme : { body } } ) => body && body.background && body.background.primary && body.background.primary };
        padding: 30px 20px;
        

        .title{
            width: 297px;
            height: 22px;
            font-size: 22px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: ${({ theme: { header } }) => header && header.text && header.text.primary && header.text.primary };
        }

        .description{
            margin-top: 10px;
            text-align: center;
            color: ${({ theme: { body } }) => body && body.text && body.text.primary && body.text.primary };
        }

        .child-lock-pin-input{
            display: flex;
            flex-direction: row;
            justify-content: center;
            margin-top: 12px;
            

            input{
                margin-right: 9px;
                width: 66px;
                height: 68px;
                border-radius: 5px;
                border: solid 1px #a6a6a6;
                background-color: #1d1d1d;
                color: #a6a6a6;
                font-size: 30px;
                padding-left: 23px;

            }//input
        }//child-lock-pin-input

        .secondary-description{
            display: flex;
            flex-direction: row;

            .secondary-description-validation{
                margin-top: 9px;
                margin-right: auto;
                width: 100%;
                height: 18px;
                opacity: 0.97;
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.29;
                letter-spacing: normal;
                color: ${({ theme: { body } }) => body && body.text && body.text.primary && body.text.primary };
            }//secondary-description-validation

            .secondary-description-forget-pin{
                margin-left: auto;
                font-size: 14px;
                color: yellow;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.29;
                width: 100%
                text-align: right;
                margin-top: 9px;
                cursor: pointer;

            }//secondary-description-forget-pin

            
        }//secondary-description

        .button_positive{

            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin-top: 25px;

            width: 100%;
            height: 46px;
            color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.primaryButton && compositeStyle.primaryButton.normal  && compositeStyle.primaryButton.normal.text };
            background-color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.primaryButton && compositeStyle.primaryButton.normal  && compositeStyle.primaryButton.normal.background };
            font-size: 16px;
            font-weight: 900;
            border-radius: 5px;
            border: solid 1px #ffd200;
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

            :hover{
                color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.primaryButton && compositeStyle.primaryButton.focussed  && compositeStyle.primaryButton.focussed.text };
                background-color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.primaryButton && compositeStyle.primaryButton.focussed && compositeStyle.primaryButton.focussed.background };
            }
            
        }//button_positive
        .button_negative{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin-top: 15px;
            width: 100%;
            height: 46px;
            font-size: 16px;
            font-weight: 900;
            border-radius: 5px;
            border: solid 1px #ffd200;
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
            color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.secondaryButton && compositeStyle.secondaryButton.normal  && compositeStyle.secondaryButton.normal.text };
            background-color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.secondaryButton && compositeStyle.secondaryButton.normal  && compositeStyle.secondaryButton.normal.background };
            border-color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.secondaryButton && compositeStyle.secondaryButton.normal  && compositeStyle.secondaryButton.normal.stroke };
            :hover{
                color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.secondaryButton && compositeStyle.secondaryButton.focussed  && compositeStyle.secondaryButton.focussed.text };
                background-color: ${({ theme: { compositeStyle } }) => compositeStyle && compositeStyle.secondaryButton && compositeStyle.secondaryButton.focussed  && compositeStyle.secondaryButton.focussed.background };
            }
        }//button_negative

    }//child-lock-wrapper
}
`

export default KidsPinPopUp
